module.exports = __webpack_public_path__ + "static/img/v0.058e7c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v0.svg
// module id = mhYR
// module chunks = 0